/* esm.sh - applesauce-core@5.2.0 */
export * from "/*applesauce-core@5.2.0/esnext/applesauce-core.mjs";
